<div class="p-grid">
  <div class="p-col-12 pl-0 pr-0 pb-0">
    <div class="row border-bottom">
      <div class="col-md-10 py-3 px-0 pl-1">
        <h5 class="switchHead m-0">Switch mode to update details</h5>
      </div>
      <div class="col-md-2 p-0 align-items-center justify-content-end d-flex">
        <i (click)="closePopup(false)" class="close-icon pi pi-times"></i>
      </div>
    </div> 
    <form class="col-12" *ngIf="isVisible">
      <div class="p-grid">
        <div class="p-col-12 pb-3 highlighted-box">
          <div class="p-grid customSelection">
            <div class="w-100 pb-2 requestPortion">
              Send request to the individual requesting for Data & Documents
              <p-inputSwitch
                name="requestData"
                (onChange)="onChangeOption($event.checked)"
                [(ngModel)]="isrequestDataDocument"
                class="pl-2 pull-right"
              >
              </p-inputSwitch>
            </div>
            <!-- <div class="w-100 pb-2">
              <label class="create-task-for-label">How do you want to fill the individual details?</label>
            </div>
            <div *ngFor="let category of categoriesTypes" class="w-100 pb-3 radioCustom">
                <p-radioButton 
                    [inputId]="category.key" 
                    name="category" 
                    [value]="category" 
                    [(ngModel)]="selectedCategory"></p-radioButton>
                <label [for]="category.key" class="ml-2">
                    {{ category.name }}
                </label>
            </div> -->
          </div>
        </div>
        <div class="p-col-12 mb-2 pb-2 highlighted-box" id="tabCustom">
          <div class="p-grid">
            <div class="w-100 pb-2">
              <label class="create-task-for-label">Tab Visibility</label>
            </div>
            <div *ngFor="let category of categories" class="w-100 field-checkbox pb-2">
              <p-checkbox  
                  [(ngModel)]="selectedCategories"
                  [label]="category.name"
                  name="group"
                  [value]="category" 
                  (onChange)="checkValue($event)"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="col-12 savePortion">
          <button
            pButton
            class="ml-3 pull-right"
            type="button"
            label="Update Now"
            title="Update Now" 
            (click)="onSubmit()"
          ></button>
          <button
            pButton
            type="button"
            label="I will go with the same"
            title="I will go with the same"
            (click)="closePopup({saved: false, data:null, cancel: true })"
            class="p-button-secondary pull-right"
          ></button>
        </div>
      </div>
    </form>
  </div>
</div>
